import { render, staticRenderFns } from "./DefaultError.vue?vue&type=template&id=43a64517&scoped=true&"
import script from "./DefaultError.vue?vue&type=script&lang=ts&"
export * from "./DefaultError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a64517",
  null
  
)

export default component.exports